<template>
  <div class="display--inline-block">
    <button class="button button--small button--light" @click="exportNumbers" :disabled="loading">
      <i class="fa fa-spin fa-spinner" v-show="loading"></i>
      <span v-show="!loading">{{ $_('export_inactive_numbers') }}</span>
    </button>
    <span v-if="err" class="form__field"><span class="parsley-error">{{ err }}</span></span>
  </div>
</template>

<script>
import { downloadCsv } from './utils';

export default {
  data () {
    return {
      user: window.user,
      err: '',
      loading: false,
    }
  },
  methods: {
    exportNumbers: function() {
      let self = this;
      self.loading = true;
      self.$http.get(`/admin/numbers/exportInactive`).then(
        function(response) {
          if (response.data) {
            downloadCsv(`inactive-numbers.csv`, response.data)
          }
          self.loading = false;
        },
        function(error) {
          console.error(error);
          self.err = error.response.data;
          self.loading = false;
        }
      )
    },
  }
}
</script>

<style lang="scss">
.daterangepicker {
  border-radius: 0;

  .calendars {
    display: grid;
    grid-template-columns: auto auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/ExportInactiveNumbers.vue